import { Typography, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../redux/hook'
import { getSelectedTimezoneLabel } from '../../utils/TimezoneOptions'
import { ReactElement } from 'react'

const TzRow = styled('div')({
    color: 'gray',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
})

const TzLabel = styled(Typography)({
    fontSize: '14px',
    fontWeight: 600,
}) as typeof Typography

const TimeZoneDisplay = (): ReactElement | null => {
    const { t } = useTranslation()
    const userLocalization = useAppSelector(
        (state) => state.user.user?.preferences?.localization,
    )
    const userPreferredTimeZone =
        userLocalization?.timeZone ||
        Intl.DateTimeFormat().resolvedOptions().timeZone
    const selectedTimezoneLabel = getSelectedTimezoneLabel(
        userPreferredTimeZone,
    )

    if (!userPreferredTimeZone) return null

    return (
        <TzRow>
            <div>
                <TzLabel component="span">{t('Time Zone')}:</TzLabel>{' '}
                <span>{selectedTimezoneLabel}</span>
            </div>
        </TzRow>
    )
}

export default TimeZoneDisplay
